// catalog_manager's read-only "Incoming requests" screen — GET
// /catalog-manager/requests (list) and GET /catalog-manager/requests/:id
// (detail). A brand new, deliberately narrow pair of hooks, not a reuse of
// hooks/useAdminRequests.js — that file's queries carry organization
// identity, assignment, and quotation/status data this role must never see
// (see backend/src/routes/catalogManagerRequestRoutes.js's own header
// comment for the exact scope). Same TanStack Query + apiClient pattern as
// every other admin hook file.

import { useQuery } from '@tanstack/react-query';
import apiClient from 'shared/api/client.js';

const LIST_KEY = ['catalogManager', 'requests'];

// GET /catalog-manager/requests — { id, ref_no, needed_by, created_at,
// line_count } per row, every incoming request, no status/organization/
// assignment filter (this role has no legitimate reason to slice by any of
// those — see requestRepository.listForCatalogManager's own comment).
export function useCatalogManagerRequests() {
  return useQuery({
    queryKey: LIST_KEY,
    queryFn: () => apiClient.get('/catalog-manager/requests'),
    select: (data) => data.requests,
  });
}

// GET /catalog-manager/requests/:id — { id, ref_no, needed_by, lines: [{
// id, raw_description, raw_unit, qty, matched_product_id,
// matched_product_name }] }. 404 (REQUEST_NOT_FOUND) surfaces through
// TanStack's isError/error, same as every other detail hook in this app.
export function useCatalogManagerRequestDetail(requestId) {
  return useQuery({
    queryKey: ['catalogManager', 'requestDetail', requestId ?? null],
    queryFn: () => apiClient.get(`/catalog-manager/requests/${requestId}`),
    select: (data) => data.request,
    enabled: Boolean(requestId),
  });
}

export default useCatalogManagerRequests;
